import { Box, Text } from '@mantine/core';
import { IconButton } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { usePlatforma } from '../../platforma';

// cererea valabila este intotdeauna cea mai recenta cerere semnata;
// cererea trimisa poate fi descarcata si inainte sa fie semnata de profesor
function DownloadPage({ student, cerere, cerereSemnata }) {
    const descarca = (c, semnata) => {
        const downloadLink = document.createElement('a');
        const sufix = semnata ? '' : ' (nesemnată de profesor)';
        downloadLink.href = c.fisier;
        downloadLink.download = `Cerere licență ${student.nume + ' ' + student.prenume} - ${c.titlu}${sufix}.pdf`;
        downloadLink.click();
    };

    const { inchisa } = usePlatforma();
    // cea mai recenta cerere, daca inca asteapta semnatura profesorului;
    // dupa inchidere studentul isi poate descarca orice cerere trimisa, chiar si una cu modificari cerute
    const cerereNesemnata = cerere && cerere.e_semnat === 0 && (inchisa || !cerere.mesaj_modificari) ? cerere : null;
    // profesorul a cerut modificari, iar studentul nu a incarcat inca cererea corectata
    const modificariSolicitate = !!cerere?.mesaj_modificari;
    // totul e gata doar daca cererea semnata e si cea mai recenta
    const totulGata = !cerereNesemnata && !modificariSolicitate;

    const butonNesemnata = cerereNesemnata && (
        <IconButton color="primary" onClick={() => descarca(cerereNesemnata, false)}>
            Descarcă cererea trimisă (nesemnată de profesor) <DownloadIcon />
        </IconButton>
    );

    return (
        <Box bg="white" p="50px" mt="55px" align="center">
        {student && student?.e_repartizat && cerereSemnata ? (
          <Box>
            {totulGata ? (
              <Text>Cererea ta este semnată de către profesorul coordonator. Nu mai rămâne nimic de făcut. Felicitări!</Text>
            ) : (
              <Text>Ai o cerere semnată anterior de profesorul coordonator, cu titlul „{cerereSemnata.titlu}”.</Text>
            )}
            {modificariSolicitate && (
              <Text c="orange.8" mt="xs">
                {inchisa
                  ? 'Profesorul coordonator a solicitat modificări, dar platforma s-a închis înainte de încărcarea unei cereri corectate. Cererea valabilă rămâne cea semnată anterior.'
                  : 'Profesorul coordonator a solicitat modificări pentru cererea ta. Întoarce-te la pasul „Încarcă cererea” pentru a încărca o cerere corectată. Până atunci, cererea valabilă rămâne cea semnată anterior.'}
              </Text>
            )}
            <IconButton color="primary" onClick={() => descarca(cerereSemnata, true)}>Descarcă cererea semnată <DownloadIcon /></IconButton>
            {cerereNesemnata && (
              <>
                {!modificariSolicitate && (
                  <Text c="orange.8" mt="xs">
                    {inchisa
                      ? `Cererea corectată trimisă de tine, cu titlul „${cerereNesemnata.titlu}”, nu a fost semnată înainte de închiderea platformei. Cererea valabilă rămâne cea semnată anterior.`
                      : `Cererea corectată trimisă de tine, cu titlul „${cerereNesemnata.titlu}”, așteaptă semnătura profesorului. Până atunci, cererea valabilă este cea semnată anterior.`}
                  </Text>
                )}
                {butonNesemnata}
              </>
            )}
            <lottie-player src="https://assets5.lottiefiles.com/packages/lf20_w9yhybo7.json" background="transparent" speed="1" style={{ height: '300px' }} loop autoplay></lottie-player>
          </Box>
        ) : (
          <Box sx={{ my: 4, mx: 0, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Text>
              {inchisa
                ? 'Platforma s-a închis înainte ca cererea ta să fie semnată de profesorul coordonator. Poți descărca cererea pe care ai trimis-o.'
                : 'Gata, mai trebuie doar să aștepți! Cererea ta nu este încă semnată de către profesorul coordonator. Vei primi un mail imediat ce profesorul o semnează.'}
            </Text>
            {butonNesemnata}
            <lottie-player src="https://assets5.lottiefiles.com/packages/lf20_jogp4tqe.json" background="transparent" speed="0.6" style={{ height: '300px' }} loop autoplay></lottie-player>
          </Box>
        )}
      </Box>
    );
}

export default DownloadPage;
